import { BaSeParagraph, BaSeSmall2 } from '@base/react';
import React from 'react';
import { ContainerIterations } from './box-iterations-style';

function MessageIteration({ msg, bgColor, marginValue, hour, radiusValue }) {
  return (
    <ContainerIterations
      marginValue={marginValue}
      radiusValue={radiusValue}
      bgColor={bgColor}
    >
      <BaSeParagraph>{msg}</BaSeParagraph>
      <BaSeSmall2 isThin>{hour}</BaSeSmall2>
    </ContainerIterations>
  );
}

export default MessageIteration;
